import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

export const Message = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
}))
